import useLocationIntradayConfigs, {
  IDataType as ILocationIntradayConfigsDataType,
} from './useLocationIntradayConfigs'
import useUploadReport, {
  IDataType as IUploadReportDataType,
} from './useUploadReport'

export type IVariablesType =
  | 'wingitnorthLocationIntradayConfigs'
  | 'wingitnorthUploadReport'

export type IDataType = ILocationIntradayConfigsDataType & IUploadReportDataType

export const hooks = [
  ['wingitnorthLocationIntradayConfigs', useLocationIntradayConfigs],
  ['wingitnorthUploadReport', useUploadReport],
] as const
